import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../ui';

import './CardButton.module.scss';

export default function CardShopButton({ onShop }) {
  return (
    <Button
      appearance="primary-neue"
      onClick={onShop}
      testID="product-shop-button"
    >
      Buy Now
    </Button>
  );
}
CardShopButton.propTypes = {
  onShop: PropTypes.func,
};
CardShopButton.defaultProps = {
  onShop: null,
};
